<mat-dialog-content style="padding: 0; height: 100%; display: flex; flex-direction: column; min-height:94%;" data-cy="tdo-notes-expanded-dialog">
  <!-- Main Container -->
  <div style="display: flex; flex-direction: column; height: 100%; flex-grow: 1;" data-cy="tdo-notes-expanded-container">
    <!-- Header Section -->
    <div style="
        padding: 4px;
        display: flex;
        flex-shrink: 0;
        min-height: 60px;
        background-color: var(--tdo-background);
        border-top-left-radius: var(--border-radius);
        border-top-right-radius: var(--border-radius);
        position: sticky;
        top: 0;
        z-index: 1;
      " data-cy="tdo-notes-expanded-header">
      <!-- Emergency Information Icon with Badge -->
      <div [matBadge]="alertNotes.length.toString()" matBadgeSize="small" matBadgeColor="warn" [ngStyle]="{
          color: storedNoteFilterSettings.isShowAlertNotes ? 'red' : '#cccccc'
        }" [matTooltip]="
          storedNoteFilterSettings.isShowAlertNotes
            ? 'Hide alert notes'
            : 'Show alert notes'
        " (click)="onEmergencyInformationClick()" style="
          cursor: pointer;
          text-align: center;
          position: relative;
          margin-top: 14px;
          margin-right: 18px;
        " data-cy="tdo-notes-expanded-alert-toggle">
        <mat-icon>error_outline</mat-icon>
      </div>

      <!-- Radio Buttons for Case Selection -->
      <div style="position: relative; margin-top: 1px; margin-left: 24px" data-cy="tdo-notes-expanded-case-selection">
        <div style="display: flex; width: 220px; align-items: center">
          <div style="flex-basis: 50px">
            <b>Case:</b>
          </div>
          <div>
            <mat-radio-group [(ngModel)]="isShowAllCases" (ngModelChange)="onCasesSelectionChange($event)"
              aria-label="Select an option" data-cy="tdo-notes-expanded-case-radio-group">
              <mat-radio-button [value]="true" data-cy="tdo-notes-expanded-case-all">All</mat-radio-button>
              <mat-radio-button [value]="false" data-cy="tdo-notes-expanded-case-current">Current</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <!-- Categories Filter -->
      <div style="position: relative; margin-top: 1px; margin-left: 24px" data-cy="tdo-notes-expanded-categories-filter">
        <div style="display: flex; max-width: 284px">
          <span class="tdo-note-info-item" style="
              font-size: 12px;
              flex: 1;
              position: relative;
              top: 3px;
              margin-left: 0;
            " data-cy="tdo-notes-expanded-categories-label">Categories</span>
          <!-- Categories Multiselect Menu -->
          <app-tdo-notes-multiselect-menu #categoryDropdown [isShowMenuLeft]="false" tooltip="Categories"
            type="category" [noteId]="" [selectableItems]="notesCategories"
            [categoryValues]="storedNoteFilterSettings.notesCategories" (categorySelectionComplete)="
              onFilterCategoryDropdownSelectionComplete($event)
            " [dropdownMenuYOffset]="-10"
            style="height: 20px; position: absolute; right: 0" data-cy="tdo-notes-expanded-categories-menu"></app-tdo-notes-multiselect-menu>
          <!-- Clear Categories Button -->
          <div style="
              flex-basis: 30px;
              font-size: 10px;
              margin-top: 6px;
              margin-right: 20px;
              opacity: 0.6;
              cursor: pointer;
            " (click)="onFilterCategorySettingsReset()" data-cy="tdo-notes-expanded-categories-clear">
            Clear
          </div>
        </div>
        <!-- Display Selected Categories -->
        <div class="tdo-note-category-pill" style="
            flex: 1;
            position: relative;
            margin-top: 8px;
            margin-right: 2px;
            max-width: 300px;
            height: 23px;
            max-height: 23px;
            overflow-y: auto;
            overflow-x: hidden;
          " data-cy="tdo-notes-expanded-categories-selected">
          <div *ngFor="let category of storedNoteFilterSettings.notesCategories" data-cy="tdo-notes-expanded-category-item">
            {{ category.enumNoteCategory.ItemDisplayValue }}
          </div>
        </div>
      </div>

      <!-- Types Filter -->
      <div style="position: relative; margin-top: 1px; margin-left: 24px" data-cy="tdo-notes-expanded-types-filter">
        <div style="display: flex; max-width: 284px">
          <span class="tdo-note-info-item" style="
              font-size: 12px;
              flex: 1;
              position: relative;
              top: 3px;
              margin-left: 0;
            " data-cy="tdo-notes-expanded-types-label">Types</span>
          <!-- Types Multiselect Menu -->
          <app-tdo-notes-multiselect-menu #typeDropdown tooltip="Types" type="type" [noteId]=""
            [selectableItems]="notesTypes" [typeValues]="storedNoteFilterSettings.notesTypes" (typeSelectionComplete)="
              onFilterTypeDropdownSelectionComplete($event)
            " [dropdownMenuYOffset]="-10"
            style="height: 20px; position: absolute; right: 0" data-cy="tdo-notes-expanded-types-menu"></app-tdo-notes-multiselect-menu>
          <!-- Clear Types Button -->
          <div style="
              flex-basis: 30px;
              font-size: 10px;
              margin-top: 6px;
              margin-right: 20px;
              opacity: 0.6;
              cursor: pointer;
            " (click)="onFilterTypeSettingsReset()" data-cy="tdo-notes-expanded-types-clear">
            Clear
          </div>
        </div>
        <!-- Display Selected Types -->
        <div class="tdo-note-type-pill" style="
            flex: 1;
            position: relative;
            margin-top: 8px;
            margin-right: 2px;
            max-width: 300px;
            height: 46px;
            max-height: 46px;
            overflow-y: auto;
            overflow-x: hidden;
          " data-cy="tdo-notes-expanded-types-selected">
          <div *ngFor="let type of storedNoteFilterSettings.notesTypes" data-cy="tdo-notes-expanded-type-item">
            {{ type.enumNoteType.ItemDisplayValue }}
          </div>
        </div>
      </div>

      <!-- View Options Checkboxes -->
      <div class="tdo-notes-filters-checkboxes" style="
          display: flex;
          flex-direction: row;
          line-height: 1;
          color: black;
          font-size: 12px;
          padding: 3px 6px 3px 6px;
          margin-left: 12px;
        " data-cy="tdo-notes-expanded-view-options">
        <div style="display: flex; flex-direction: column" data-cy="tdo-notes-expanded-view-checkboxes">
          <mat-checkbox aria-label="Full View" [(ngModel)]="storedNoteFilterSettings.isFullView"
            (change)="onCheckboxChange($event)" style="position: relative; flex: 1; height: 10px" data-cy="tdo-notes-expanded-full-view-checkbox">Full
            View</mat-checkbox>
          <mat-checkbox aria-label="Condensed View" [(ngModel)]="storedNoteFilterSettings.isCondensedView"
            (change)="onCheckboxChange($event)" style="position: relative; flex: 1; height: 10px" data-cy="tdo-notes-expanded-condensed-view-checkbox">Condensed
            View</mat-checkbox>
        </div>
        <div style="display: flex; flex-direction: column; margin-left: 10px" data-cy="tdo-notes-expanded-created-checkboxes">
          <mat-checkbox aria-label="Created On" [(ngModel)]="storedNoteFilterSettings.isShowCreatedOn"
            (change)="onCheckboxChange($event)" style="position: relative; flex: 1; height: 10px" data-cy="tdo-notes-expanded-created-on-checkbox">Show Created
            On</mat-checkbox>
          <mat-checkbox aria-label="Created By" [(ngModel)]="storedNoteFilterSettings.isShowCreatedBy"
            (change)="onCheckboxChange($event)" style="position: relative; flex: 1; height: 10px" data-cy="tdo-notes-expanded-created-by-checkbox">Show Created
            By</mat-checkbox>
        </div>
        <div style="display: flex; flex-direction: column; margin-left: 10px" data-cy="tdo-notes-expanded-modified-checkboxes">
          <mat-checkbox aria-label="Modified On" [(ngModel)]="storedNoteFilterSettings.isShowModifiedOn"
            (change)="onCheckboxChange($event)" style="position: relative; flex: 1; height: 10px" data-cy="tdo-notes-expanded-modified-on-checkbox">Show Modified
            On</mat-checkbox>
          <mat-checkbox aria-label="Modified By" [(ngModel)]="storedNoteFilterSettings.isShowModifiedBy"
            (change)="onCheckboxChange($event)" style="position: relative; flex: 1; height: 10px" data-cy="tdo-notes-expanded-modified-by-checkbox">Show Modified
            By</mat-checkbox>
        </div>
      </div>

      <!-- Spacer to Push Content to the Left -->
      <div style="flex: 1"></div>
    </div>
    <!-- End of Header Section -->

    <!-- Notes Content Section -->
    <div style="
        flex: 1;
        overflow-y: auto;
        padding: 0;
        display: flex;
        flex-direction: column;
        height: 100%;
      " data-cy="tdo-notes-expanded-content">
      <!-- Loading Spinner -->
      <ng-container *ngIf="isLoading" style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);">
        <app-tdo-progress-spinner></app-tdo-progress-spinner>
      </ng-container>

      <!-- Content displayed when not loading -->
      <ng-container *ngIf="!isLoading" style="flex: 1">
        <!-- Message When No Notes are Available -->
        <ng-container *ngIf="
            !storedNoteFilterSettings.isShowAlertNotes &&
            filteredNotes.length === 0">
          <div style="
              width: fit-content;
              margin: 30px auto 0 auto;
              color: var(--tdo-primary);
              font-size: 20px;
              font-weight: 500;
            ">
            The selected patient / case has no notes.
          </div>
        </ng-container>

        <!-- Notes Displayed -->
        <ng-container *ngIf="storedNoteFilterSettings.isShowAlertNotes">
          <div *ngFor="let note of filteredNotes" style="
              padding: 4px;
              margin-bottom: 8px;
              background-color: var(--tdo-primary);
              color: white;
              border-radius: 4px;
              overflow: hidden;
            " data-cy="tdo-notes-expanded-alert-note-item">
            <!-- Note Header -->
            <div style="display: flex; position: relative; top: 4px" data-cy="tdo-notes-expanded-alert-note-header">
              <!-- Created On -->
              <div style="font-size: 12px" *ngIf="storedNoteFilterSettings.isShowCreatedOn" data-cy="tdo-notes-expanded-alert-note-created-on">
                Created On
                <span style="font-weight: bold">{{
                  getDate(note.xauditCreatedOn)
                  }}</span>
              </div>
              <!-- Created By -->
              <div style="font-size: 12px; margin-left: 12px" *ngIf="storedNoteFilterSettings.isShowCreatedBy" data-cy="tdo-notes-expanded-alert-note-created-by">
                By
                <span style="font-weight: bold">{{ note.xauditCreatedByUser?.FirstName }}
                  {{ note.xauditCreatedByUser?.LastName }}</span>
              </div>
              <!-- Categories -->
              <div style="flex: 1" data-cy="tdo-notes-expanded-alert-note-categories">
                <div *ngFor="let category of note.dataNoteCategories" data-cy="tdo-notes-expanded-alert-note-category">
                  {{ category.enumNoteCategory.ItemDisplayValue + ", " }}
                </div>
              </div>
              <!-- Action Icons -->
              <div style="
                  display: flex;
                  width: fit-content;
                  color: var(--tdo-primary-accent);
                  position: relative;
                  top: -5px;
                " data-cy="tdo-notes-expanded-alert-note-actions">
                <!-- Lock Icon if Note is Locked -->
                <mat-icon *ngIf="isNoteLocked(note)" style="flex: 1; color: white; cursor: default"
                  matTooltip="Note locked" data-cy="tdo-notes-expanded-alert-note-lock-icon">lock</mat-icon>
                <!-- Note Builder Icon -->
                <mat-icon *ngIf="!isNoteLocked(note)" style="flex: 1; cursor: pointer; margin-right: 10px"
                  matTooltip="Note Builder" (click)="openNoteBuilder(note)" data-cy="tdo-notes-expanded-alert-note-builder-button">notes</mat-icon>
                <!-- Macro Notes Icon -->
                <mat-icon *ngIf="!isNoteLocked(note)" style="flex: 1; cursor: pointer" matTooltip="Macro Notes"
                  (click)="openMacroNotes(note)" data-cy="tdo-notes-expanded-alert-note-macro-button">account_tree</mat-icon>
                <!-- Delete Note Icon -->
                <mat-icon *ngIf="!isNoteLocked(note)" style="flex: 1; cursor: pointer" matTooltip="Delete Note"
                  (click)="deleteNote(note)" data-cy="tdo-notes-expanded-alert-note-delete-button">delete</mat-icon>
              </div>
            </div>

            <!-- Note Content -->
            <div class="tdo-notes-content" data-cy="tdo-notes-expanded-alert-note-content">
              <textarea cdkTextareaAutosize [readOnly]="isNoteLocked(note)" [(ngModel)]="note.Note"
                (appInputFinished)="onNoteInput($event, note)" [delayMs]="500" rows="5" style="
                  line-height: 1.3;
                  color: #888888;
                  background-color: #f4f4f4;
                  border: unset;
                  height: fit-content;
                " data-cy="tdo-notes-expanded-alert-note-textarea"></textarea>
            </div>

            <!-- Note Footer -->
            <div style="line-height: 2" data-cy="tdo-notes-expanded-alert-note-footer">
              <!-- Categories (Full View) -->
              <div *ngIf="!storedNoteFilterSettings.isCondensedView" class="tdo-note-info" style="position: relative">
                <span class="tdo-note-info-item" style="flex-basis: 70px">Categories</span>
                <div class="tdo-note-category-pill" style="flex: 1">
                  <div *ngFor="let category of note.dataNoteCategories">
                    {{ category.enumNoteCategory.ItemDisplayValue }}
                  </div>
                </div>
                <app-tdo-notes-multiselect-menu tooltip="Categories" type="category" [noteId]="note.NoteId"
                  [selectableItems]="notesCategories" [categoryValues]="note.dataNoteCategories"
                  (categorySelectionComplete)="
                    onCategoryDropdownSelectionComplete($event, note)
                  " *ngIf="i != filteredNotes.length - 1 && !isNoteLocked(note)" [dropdownMenuYOffset]="-10"
                  style="height: 20px; position: absolute; right: 0"></app-tdo-notes-multiselect-menu>
                <app-tdo-notes-multiselect-menu tooltip="Categories" type="category" [noteId]="note.NoteId"
                  [selectableItems]="notesCategories" [categoryValues]="note.dataNoteCategories"
                  (categorySelectionComplete)="
                    onCategoryDropdownSelectionComplete($event, note)
                  " *ngIf="i == filteredNotes.length - 1 && !isNoteLocked(note)" [dropdownMenuYOffset]="-50"
                  style="height: 20px; position: absolute; right: 0"></app-tdo-notes-multiselect-menu>
              </div>
              <!-- Types (Full View) -->
              <div *ngIf="!storedNoteFilterSettings.isCondensedView" class="tdo-note-info" style="position: relative">
                <span class="tdo-note-info-item" style="flex-basis: 70px">Types</span>
                <div class="tdo-note-type-pill" style="flex: 1">
                  <div *ngFor="let type of note.dataNoteTypes">
                    {{ type.enumNoteType?.ItemDisplayValue }}
                  </div>
                </div>
                <app-tdo-notes-multiselect-menu tooltip="Types" type="type" [noteId]="note.NoteId"
                  [selectableItems]="notesTypes" [typeValues]="note.dataNoteTypes" (typeSelectionComplete)="
                    onTypeDropdownSelectionComplete($event, note)
                  " *ngIf="i != filteredNotes.length - 1 && !isNoteLocked(note)" [dropdownMenuYOffset]="-10"
                  style="height: 20px; position: absolute; right: 0"></app-tdo-notes-multiselect-menu>
                <app-tdo-notes-multiselect-menu tooltip="Types" type="type" [noteId]="note.NoteId"
                  [selectableItems]="notesTypes" [typeValues]="note.dataNoteTypes" (typeSelectionComplete)="
                    onTypeDropdownSelectionComplete($event, note)
                  " *ngIf="i == filteredNotes.length - 1 && !isNoteLocked(note)" [dropdownMenuYOffset]="-50"
                  style="height: 20px; position: absolute; right: 0"></app-tdo-notes-multiselect-menu>
              </div>
              <!-- Modified On -->
              <div style="font-size: 12px" *ngIf="storedNoteFilterSettings.isShowModifiedOn">
                Modified On
                <span style="font-weight: bold">{{
                  getDate(note.xauditModifiedOn)
                  }}</span>
              </div>
              <!-- Modified By -->
              <div style="font-size: 12px" *ngIf="storedNoteFilterSettings.isShowModifiedBy">
                Modified By
                <span style="font-weight: bold">{{ note.xauditModifiedByUser?.FirstName }}
                  {{ note.xauditModifiedByUser?.LastName }}</span>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Regular Notes Section -->
        <ng-container *ngIf="filteredNotes.length > 0">
          <div *ngFor="let note of filteredNotes; let i = index" style="
              margin-right: 3px;
              margin-bottom: 2px;
              padding: 4px;
              border-radius: var(--border-radius);
              background-color: var(--tdo-primary);
              color: white;
            " data-cy="tdo-notes-expanded-note-item">
            <!-- Note Header -->
            <div style="display: flex; position: relative; top: 4px">
              <!-- Created On -->
              <div style="font-size: 12px" *ngIf="storedNoteFilterSettings.isShowCreatedOn">
                Created On
                <span style="font-weight: bold">{{
                  getDate(note.xauditCreatedOn)
                  }}</span>
              </div>
              <!-- Created By -->
              <div style="font-size: 12px; margin-left: 12px" *ngIf="storedNoteFilterSettings.isShowCreatedBy">
                By
                <span style="font-weight: bold">{{ note.xauditCreatedByUser?.FirstName }}
                  {{ note.xauditCreatedByUser?.LastName }}</span>
              </div>
              <!-- Categories and Types -->
              <div style="margin-left: 12px; font-size: 12px; flex: 1">
                <div style="display: flex; flex-direction: row; position: relative">
                  <div style="flex-basis: 85px">| Categories</div>
                  <div style="font-weight: bold; padding-left: 5px">
                    <span *ngFor="
                        let category of note.dataNoteCategories;
                        index as i
                      ">
                      {{
                      category.enumNoteCategory.ItemDisplayValue +
                      (i + 1 < note.dataNoteCategories.length ? ", " : "" ) }} </span>
                  </div>
                  <div style="flex-basis: 65px; padding-left: 12px">
                    | Types
                  </div>
                  <div style="font-weight: bold; padding-left: 5px">
                    <span *ngFor="let type of note.dataNoteTypes; index as i">
                      {{
                      type.enumNoteType.ItemDisplayValue +
                      (i + 1 < note.dataNoteTypes.length ? ", " : "" ) }} </span>
                  </div>
                </div>
              </div>
              <div style="flex: 1"></div>
              <!-- Action Icons -->
              <div style="
                  display: flex;
                  width: fit-content;
                  color: var(--tdo-primary-accent);
                  position: relative;
                  top: -5px;
                ">
                <mat-icon *ngIf="isNoteLocked(note)" style="flex: 1; color: white; cursor: default"
                  matTooltip="Note locked">lock</mat-icon>
                <mat-icon *ngIf="!isNoteLocked(note)" style="flex: 1; cursor: pointer; margin-right: 10px"
                  matTooltip="Note Builder" (click)="openNoteBuilder(note)">notes</mat-icon>
                <mat-icon *ngIf="!isNoteLocked(note)" style="flex: 1; cursor: pointer" matTooltip="Macro Notes"
                  (click)="openMacroNotes(note)">account_tree</mat-icon>
                <mat-icon *ngIf="!isNoteLocked(note)" style="flex: 1; cursor: pointer" matTooltip="Delete Note"
                  (click)="deleteNote(note)">delete</mat-icon>
              </div>
            </div>

            <!-- Note Content -->
            <div class="tdo-notes-content">
              <textarea cdkTextareaAutosize [readOnly]="isNoteLocked(note)" [(ngModel)]="note.Note"
                (appInputFinished)="onNoteInput($event, note)" [delayMs]="500" rows="5" style="
                  line-height: 1.3;
                  color: #888888;
                  background-color: #f4f4f4;
                  border: unset;
                  height: fit-content;
                "></textarea>
            </div>

            <!-- Note Footer -->
            <div style="line-height: 2">
              <div *ngIf="!storedNoteFilterSettings.isCondensedView" class="tdo-note-info" style="position: relative">
                <span class="tdo-note-info-item" style="flex-basis: 70px">Categories</span>
                <div class="tdo-note-category-pill" style="flex: 1">
                  <div *ngFor="let category of note.dataNoteCategories">
                    {{ category.enumNoteCategory.ItemDisplayValue }}
                  </div>
                </div>
              </div>
              <div *ngIf="!storedNoteFilterSettings.isCondensedView" class="tdo-note-info" style="position: relative">
                <span class="tdo-note-info-item" style="flex-basis: 70px">Types</span>
                <div class="tdo-note-type-pill" style="flex: 1">
                  <div *ngFor="let type of note.dataNoteTypes">
                    {{ type.enumNoteType?.ItemDisplayValue }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</mat-dialog-content>
<div class="section section-footer" style="flex-basis: 46px; min-height: 46px; padding-top: 6px" data-cy="tdo-notes-expanded-footer">
  <div style="flex: 1; margin-right: 6px"></div>
  <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px" data-cy="tdo-notes-expanded-ok-button">
    Ok
  </button>
</div>